import { LoaderCircle } from "lucide-react";

import { Button } from "@/components/ui";

interface ActionButtonProps {
    label: string;
    variant?: "default" | "outline" | "destructive";
    isLoading?: boolean;
    onClick?: () => void;
    disabled?: boolean;
    className?: string;
}

export function ActionButton({ label, variant = "default", isLoading, onClick, disabled, className }: ActionButtonProps) {
    return (
        <Button
            onClick={onClick}
            disabled={isLoading || disabled}
            className={className}
            variant={variant}
        >
            {isLoading && (
                <LoaderCircle className={`animate-spin -ml-1 mr-2 h-4 w-4 ${variant === 'outline' ? 'text-foreground' : 'text-white'}`} />
            )}
            {label}
        </Button>
    );
} 